<template>
  <div class="animated fadeIn">
    <div class="font-bold mb-10">Sales Best of the Best</div>
    <div class="box-mini mb-10">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-7">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="changeDateReport" :config="exportConfig" class="font-13 text-center" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
                <td v-if="getRoleId == 1">
                  <a @click="syncData()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Sync</a>

                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select :disabled="(getRoleId == 17 || getRoleId == 31 || getRoleId == 22 || getRoleId == 1 || getRoleId == 33) || getRoleMappingId.includes(19) ? false : true" name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-5 text-right hidden">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchDate)" v-model="searchDate" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <div class="col-12">
          <div class="overflow-auto">
            <table class="table table-responsive table-striped mb-0">
              <thead>
                <tr>
                  <th><strong> Employee ID </strong></th>
                  <th><strong> Branch Name </strong></th>
                  <th><strong> Membership Advisor Name </strong></th>
                  <th><strong> Sales Blanking Days </strong></th>
                  <th><strong> Total Unit Sales Dues </strong></th>
                  <th><strong> Total Unit Sales Package</strong></th>
                  <th><strong> Total Unit Sales </strong></th>
                  <th><strong> Fresh Membership </strong></th>
                  <th><strong> Re-Join Membership </strong></th>
                  <th><strong> Continue Membership </strong></th>
                  <th><strong> Total Revenue Membership Dues </strong></th>
                  <th><strong> Total Revenue Membership Term </strong></th>
                  <th><strong> Total Session POS 1 </strong></th>
                  <th><strong> Total Revenue POS 1 </strong></th>
                  <th><strong> Total Session POS 2 </strong></th>
                  <th><strong> Total Revenue POS 2 </strong></th>
                  <th><strong> Total Revenue POS 1 + POS 2 </strong></th>
                  <th><strong> Commision Dues </strong></th>
                  <th><strong> Commision Packages </strong></th>
                  <!-- <th><strong> Commision Term </strong></th> -->
                  <th><strong> Commision POS 1 </strong></th>
                  <th><strong> Commision POS 2 </strong></th>
                  <th><strong> Total Commision  </strong></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="values in items" :key="values.sales_id">
                  <td>
                    {{values.sales_id}}
                  </td>
                  <td>
                    {{values.branch ? values.branch.name : "-"}}
                  </td>
                  <td>
                    {{values.fullname}}
                  </td>
                  <td>
                    {{values.sales_blanking_days}}
                  </td>
                  <td>
                    {{values.total_unit_sales_dues}}
                  </td>
                  <td>
                    {{values.total_unit_sales_package}}
                  </td>
                  <td>
                    {{values.total_unit_sales}}
                  </td>
                  <td>
                    {{values.total_unit_sales_fresh_membership}}
                  </td>
                  <td>
                    {{values.total_unit_sales_rejoin_membership}}
                  </td>
                  <td>
                    {{values.total_unit_sales_change_membership}}
                  </td>
                  <td>
                    {{parseCurrency(values.total_revenue_membership_dues)}}
                  </td>
                  <td>
                    {{parseCurrency(values.total_revenue_membership_term)}}
                  </td>
                  <td>
                    {{values.total_session_pos_1}}
                  </td>
                  <td>
                    {{parseCurrency(values.total_revenue_pos_1)}}
                  </td>
                  <td>
                    {{values.total_session_pos_2}}
                  </td>
                  <td>
                    {{parseCurrency(values.total_revenue_pos_2)}}
                  </td>
                  <td>
                    {{parseCurrency(values.total_revenue_pos_1 + values.total_revenue_pos_2)}}
                  </td>
                  <td>
                    {{parseCurrency(values.comission_dues)}}
                  </td>
                  <td>
                    {{parseCurrency(values.comission_packages)}} <!-- Comission Packages -->
                  </td>
                  <!-- <td>
                    {{parseCurrency(values.comission_term)}}
                  </td> -->
                  <td>
                    {{parseCurrency(values.comission_pos_1)}}
                  </td>
                  <td>
                    {{parseCurrency(values.comission_pos_2)}}
                  </td>
                  <td>
                    {{parseCurrency(values.total_commision)}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'


export default {
  name: 'salesbestofthebest',
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      index: 1,
      items: [],
      dataBranch: [],
      branch_id: null,
      sortType: '',
      sortBy: '',
      searchDate: moment(new Date()).format('YYYY-MM-DD'),
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      getRoleMappingId: [],
      dateString: '27-07-1993'
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    changeDateReport(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      return 'Rp. ' + parseFloat(value).toLocaleString('id-ID', {maximumFractionDigits:2})
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    totalRevenueEach (value) {
      var pos1 = value.total_revenue_pos_1
      var pos2 = value.total_revenue_pos_2
      return pos1 + pos2
    },
    commisionEach (value) {
      var data = value
      var total = data * 5 / 100
      return total
    },
    commisionTotalEach (value) {
      var commisionDues = value.total_revenue_membership_dues * 5 / 100
      var commisionTerm = value.total_revenue_membership_term * 5 / 100
      var commisionPos1 = value.total_revenue_pos_1 * 5 / 100
      var commisionPos2 = value.total_revenue_pos_2 * 5 / 100
      return commisionDues + commisionTerm + commisionPos1 + commisionPos2
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/sales_report/best_of_the_best_new?start='+dates[0]+'&end='+dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (this.getRoleId == 3) url += '&sales_id=' + Auth.Session.get().paradigm_id

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Sales Report Best of The Best '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch(event) {
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/best_of_the_best?start=' + dates[0] + '&end=' + dates[1]

      if (event != null) {
        url += '&branch_id=' + event
      }

      if (this.getRoleId == 3) url += '&sales_id=' + Auth.Session.get().paradigm_id

      axios.get(url).then(response => {
        this.items = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    syncData() {
      this.loadingActive = true

      // console.log(JSON.stringify(this.items))
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/best_of_the_best/sync?start=' + dates[0]

      // if (this.branch_id != null) {
      //   url += '&branch_id=' + this.branch_id
      // }

      // if (this.getRoleId == 3) url += '&sales_id=' + Auth.Session.get().paradigm_id

      axios.post(url, {data: this.items}).then(response => {
        this.$swal('Sync', 'You successfully Sync Data', 'success')
        this.changeBranch(this.branch_id)
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    fetchData() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/best_of_the_best?start=' + dates[0] + '&end=' + dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (this.getRoleId == 3) url += '&sales_id=' + Auth.Session.get().paradigm_id

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })

      let url_branch = `fitness/v1/branch?paradigm_id=${this.getID}&paradigm_role_id=${this.getRoleId}`
      url_branch = `fitness/v1/branch/`;

      axios.get(url_branch).then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    var roleMapping = `${Auth.Session.get().paradigm_role_mapping_id}`.split(',')
    this.getRoleMappingId = roleMapping
    // format string to number in array
    this.getRoleMappingId = this.getRoleMappingId.map(Number)
    this.branch_id = Auth.Session.get().paradigm_branch_id && Auth.Session.get().paradigm_branch_id != 0 ? Auth.Session.get().paradigm_branch_id : null
    this.fetchData()
  }
  // watch: {
  //   changeStudioId: function () {
  //     axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
  //     axios.get(Auth.api_url+'classes_schedule/'+this.changeStudioId+'/all?sorting=asc').then(response => {
  //       this.items = response.data.data.rows
  //     }).catch(error => {
  //       console.log('error', error)
  //     })
  //   }
  // }
}
</script>

<style>
</style>
